import React from 'react';
import { Breadcrumb } from '../../pages/runtime-typechecker';
import style from './BreadCrumb.module.css';
import { Helmet } from 'react-helmet-async';
import { AppContextConsumer } from '../../AppContext';
type BreadCrumbsProps = {
  breadcrumb: Breadcrumb[];
  type?: string;
};

export default function BreadCrumbs({
  breadcrumb = [],
  type = ''
}: BreadCrumbsProps) {
  const handleBreadCrumbClick = (displayString: string, trackTemplateEvent) => {
    trackTemplateEvent(
      `Bus_SEO${type}_BreadCrumb_${
        displayString === `Home` ? `Home` : `BusTicket`
      }_Click`
    );
  };
  return (
    <AppContextConsumer>
      {({ trackTemplateEvent }) => (
        <>
          <Helmet>
            <script type="application/ld+json">
              {`
          {
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": ${JSON.stringify(
            breadcrumb.map((b, idx) => ({
              '@type': 'ListItem',
              position: String(idx + 1),
              item: {
                '@type': 'WebPage',
                '@id': b.redirectionUrl || '',
                name: b.displayString
              }
            }))
          )}
          }
        `}
            </script>
          </Helmet>
          <ul className={style.breadCrumb}>
            {breadcrumb.map((c, idx) =>
              breadcrumb.length !== idx + 1 ? (
                <li key={c.redirectionUrl}>
                  <a
                    href={c.redirectionUrl}
                    onClick={() =>
                      handleBreadCrumbClick(c.displayString, trackTemplateEvent)
                    }
                  >
                    <span itemProp="name">{c.displayString}</span>
                  </a>
                  &nbsp;&gt;&nbsp;
                </li>
              ) : (
                <li key="crntNode">
                  <span className={style.crntNode} itemProp="name">
                    {c.displayString}
                  </span>
                </li>
              )
            )}
          </ul>
        </>
      )}
    </AppContextConsumer>
  );
}
